import { ax } from 'src/client'
import {
  BANK_ACCOUNTS,
  COMMENT_INCOMING_PAYMENT,
  GET_COMPANIES,
  GET_FORWARD_PAYMENTS,
  GET_INCOMING_PAYMENT,
  GET_INCOMING_PAYMENTS,
  GET_PAYABLE_SEARCH_RESULTS,
  GET_SEARCH_RESULTS,
  POST_DEPOSIT,
  POST_FORWARD_PAYMENT,
  POST_RESOLVE_PAYMENT,
  POST_SETTLE_ETPS,
  POST_SETTLE_INVOICES,
  POST_UNMATCH_PAYMENT
} from './serviceURLS'

export function resolvePayment(paymentId, params) {
  return ax.post(POST_RESOLVE_PAYMENT.replace(':id', paymentId), params)
}

export async function settleInvoices(paymentID, invoicesToSettle) {
  return ax.post(POST_SETTLE_INVOICES.replace(':id', paymentID), {
    invoices: invoicesToSettle
  })
}

export async function settleETPs(paymentId, etpsToSettle) {
  return ax.post(POST_SETTLE_ETPS.replace(':id', paymentId), {
    etps: etpsToSettle
  })
}

export async function sendPayment(paymentID, paymentData) {
  return ax.post(POST_FORWARD_PAYMENT.replace(':id', paymentID), paymentData)
}

export async function getBankAccounts(companyID) {
  return ax.get(BANK_ACCOUNTS.replace(':id', companyID))
}

export function getIncomingPayments(params, selectedTab) {
  return ax.get(GET_INCOMING_PAYMENTS, { params })
}

export async function getIncomingPayment(paymentId) {
  return ax.get(GET_INCOMING_PAYMENT.replace(':id', paymentId))
}

export async function getForwardPayments(paymentId) {
  return ax.get(GET_FORWARD_PAYMENTS.replace(':id', paymentId))
}

export function unmatchPayment(paymentId, params) {
  return ax.post(POST_UNMATCH_PAYMENT.replace(':id', paymentId), params)
}

export function commentIncomingPayment({ incomingPaymentId, comment }) {
  return ax.post(COMMENT_INCOMING_PAYMENT.replace(':id', incomingPaymentId), {
    comment
  })
}

export function getInvoicesSearchResults(params) {
  return ax.get(GET_SEARCH_RESULTS, { params })
}

export function getCompanies(filters) {
  return ax.get(GET_COMPANIES, {
    params: {
      name_chunk: filters
    }
  })
}

export function getPayableSearchResults(id, params) {
  return ax.get(GET_PAYABLE_SEARCH_RESULTS.replace(':id', id), {
    params: {
      isin: params.number_like,
      instalment_payment_reference_number: params.payment_reference_number_like,
      client_id: params.counterparty_name_like,
      sort_by: params.sort_by,
      descending: params.descending,
      limit: params.limit
    }
  })
}

export function depositPayment(paymentId, { investorId, accountId, amount }) {
  return ax.post(POST_DEPOSIT.replace(':id', paymentId), {
    investor_id: investorId,
    account_id: accountId,
    amount
  })
}
